// extracted by mini-css-extract-plugin
module.exports = {"button":"Matches_button__ns92e","active":"Matches_active__1OOlR","top":"Matches_top__2kJne"};